import * as yup from 'yup';
import { getInventoryItemValidation } from './inventoryItemValidation.js';
import { getTaxFormValidation, getReasonsToExportValidation, getInvoiceNumberValidation } from './taxFormValidation.js';
import { CustomsReasonToExport } from '@packlink/packlink-sdk';
import { getIsSelectOption } from '../../utils/select.js';

let customFormInventoryErrorTypes = /*#__PURE__*/function (customFormInventoryErrorTypes) {
  customFormInventoryErrorTypes["MAX_WEIGHT_ERROR"] = "max-weight";
  customFormInventoryErrorTypes["MAX_VALUE_ERROR"] = "max-value";
  customFormInventoryErrorTypes["MAX_WEIGHT_AND_VALUE_ERROR"] = "max-weight-and-value";
  return customFormInventoryErrorTypes;
}({});
function getTotalWeight() {
  let items = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return items.reduce((total, item) => {
    var _item$weight, _item$numberOfItems;
    return total + ((_item$weight = item.weight) !== null && _item$weight !== void 0 ? _item$weight : 0) * ((_item$numberOfItems = item.numberOfItems) !== null && _item$numberOfItems !== void 0 ? _item$numberOfItems : 0);
  }, 0);
}
function getTotalValue() {
  let items = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return items.reduce((total, item) => {
    var _item$value, _item$numberOfItems2;
    return total + ((_item$value = item.value) !== null && _item$value !== void 0 ? _item$value : 0) * ((_item$numberOfItems2 = item.numberOfItems) !== null && _item$numberOfItems2 !== void 0 ? _item$numberOfItems2 : 0);
  }, 0);
}
const getCustomsFormValidation = (t, _ref) => {
  let {
    customsInventoryMaxWeight = Number.MAX_SAFE_INTEGER,
    customsInventoryMaxValue = Number.MAX_SAFE_INTEGER
  } = _ref;
  return {
    sender: getTaxFormValidation('sender', t),
    receiver: getTaxFormValidation('receiver', t),
    inventoryOfContents: yup.array().nullable().when('reasonsToExport', {
      is: getIsSelectOption(CustomsReasonToExport.DOCUMENTS),
      then: yup.array().nullable(),
      otherwise: yup.array().required()
    }).of(getInventoryItemValidation(t)).test('values-weight-required', '', function validateValuesAndWeight(values) {
      if (!values) {
        return this.createError({
          path: this.path,
          message: customFormInventoryErrorTypes.MAX_WEIGHT_AND_VALUE_ERROR
        });
      }
      if (getTotalValue(values) > customsInventoryMaxValue && getTotalWeight(values) > customsInventoryMaxWeight) {
        return this.createError({
          path: this.path,
          message: customFormInventoryErrorTypes.MAX_WEIGHT_AND_VALUE_ERROR
        });
      } else if (getTotalValue(values) > customsInventoryMaxValue) {
        return this.createError({
          path: this.path,
          message: customFormInventoryErrorTypes.MAX_VALUE_ERROR
        });
      } else if (getTotalWeight(values) > customsInventoryMaxWeight) {
        return this.createError({
          path: this.path,
          message: customFormInventoryErrorTypes.MAX_WEIGHT_ERROR
        });
      }
      return true;
    }),
    reasonsToExport: getReasonsToExportValidation(t, customsInventoryMaxWeight),
    invoiceNumber: getInvoiceNumberValidation(t),
    customsTerms: yup.bool().oneOf([true], t('customs-form.error.terms-required')).required(t('customs-form.error.terms-required')),
    authorised: yup.bool().oneOf([true], t('customs-form.error.signature-required')).required(t('customs-form.error.signature-required'))
  };
};

export { customFormInventoryErrorTypes, getCustomsFormValidation };
//# sourceMappingURL=customsFormValidations.js.map
